import { Breadcrumb } from "antd";
import { useLocation, Link } from "react-router-dom";

const MobileBreadcrumb = () => {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((item) => item);


    return (
        <Breadcrumb>
            <Breadcrumb.Item>
                <Link to="/" className="!text-xs sm:!text-sm md:!text-bas ">Anasayfa</Link>
            </Breadcrumb.Item>
            {pathnames.map((value, index) => {
                const url = `/${pathnames.slice(0, index + 1).join("/")}`;
                return (
                    <Breadcrumb.Item key={url}>
                        <Link className="!text-xs sm:!text-sm md:!text-bas !capitalize"  to={url}>{decodeURIComponent(value)}</Link>
                    </Breadcrumb.Item>
                );
            })}
        </Breadcrumb>
    );
};

export default MobileBreadcrumb;
